import {kmsQueries} from '@domain/kiln-monitoring'
import {useUpmPlant} from '@hconnect/upm'
import {useQuery} from '@tanstack/react-query'
import {useState, useEffect} from 'react'

import {mapToSensorReadings} from '../mappers'
import {countAreaState} from '../utils'

import {useGetKilnsInfo, useGetSignals} from './api'

export const useKilnMonitoringState = (plantId: string) => {
  const upmPlantId = useUpmPlant({plantId}).upmId
  const kilnsInfo = useGetKilnsInfo(upmPlantId, {
    enabled: !!upmPlantId
  })
  const kilns = kilnsInfo.data
  const [selectedKilnId, setSelectedKilnId] = useState<string | null>(null)
  const healthIndicators = useQuery({
    ...kmsQueries.healthIndicators(selectedKilnId!, upmPlantId),
    enabled: !!upmPlantId && !!selectedKilnId
  })
  const sensorAreas = useGetSignals(
    {plantId: upmPlantId, kilnId: selectedKilnId!},
    {
      enabled: !!upmPlantId && !!selectedKilnId,
      select: (data) => countAreaState(data, mapToSensorReadings(data))
    }
  )

  useEffect(() => {
    if (kilns && kilns.length > 0) {
      if (!selectedKilnId || !kilns.some((kiln) => kiln.id === selectedKilnId)) {
        setSelectedKilnId(kilns[0].id)
      }
    }
  }, [kilns, selectedKilnId])

  const selectedKiln = kilns?.find((kiln) => kiln.id === selectedKilnId)

  return {
    isLoading: kilnsInfo.isLoading || healthIndicators.isLoading || sensorAreas.isLoading,
    kilnsInfo,
    healthIndicators,
    sensorAreas,
    selectedKiln,
    handleSelectedKilnChange: setSelectedKilnId
  }
}
